var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.36 15.5398C29.0906 16.8119 27.4725 17.679 25.7103 18.0314C23.9481 18.3839 22.121 18.2058 20.46 17.5198L9.64 30.5598C7.66 32.5398 4.46 32.5398 2.48 30.5598C0.499995 28.5798 0.499995 25.3798 2.48 23.4198L15.52 12.5798C14.16 9.27983 14.82 5.35983 17.5 2.67983C20.06 0.119833 23.74 -0.560167 26.94 0.559833L21.16 6.33983L26.8 11.9798L32.52 6.23983C33.58 9.39983 32.88 13.0198 30.36 15.5398ZM4.62 28.4198C5.42 29.1998 6.7 29.1998 7.47999 28.4198C8.27999 27.6198 8.27999 26.3398 7.47999 25.5598C6.7 24.7598 5.42 24.7598 4.62 25.5598C4.24501 25.9413 4.03488 26.4549 4.03488 26.9898C4.03488 27.5248 4.24501 28.0383 4.62 28.4198Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.ddff7097.svg";
export { ForwardRef as ReactComponent };